import Vue from 'vue';
import handleList from '@/utils/handle';
import moment from 'moment'

// 表格判空
Vue.filter('noText', function (value) {
  if (!value) {
    value = '---'
  }
  return value
})

Vue.filter('valueFormat', function (value) {
  if (!value && value !== 0) {
    value = '---'
  }
  return value
})

/**
 * @description: 时间展示
 * @param {*} defined 自定义的格式化  如果不传，默认走 'YYYY-MM-DD HH:mm:ss' 格式
 */
Vue.filter('format', function (value, defined) {
  if (!value) {
    return '---'
  } else {
    return moment(value).format(defined || 'YYYY-MM-DD HH:mm:ss')
  }
})

/**
 * @description: 汉字 周几
 */
Vue.filter('weekFormat', function (value) {
  let week = ['日', '一', '二', '三', '四', '五', '六']
  if (!value) {
    return '---'
  } else {
    return week[moment(value).format('d')]
  }
})

// 整数位,无数据---
Vue.filter('currency', (cellValue, flag) => {
  if (!cellValue || cellValue === '') {
    return '---';
  } else {
    cellValue = Number(cellValue);
    const str = cellValue.toString().toUpperCase();
    let intPartFormat = "";
    if (flag) {
      intPartFormat = cellValue
    } else {
      intPartFormat = cellValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
    }
    return intPartFormat

  }
});

// 整数位,无数据0
Vue.filter('quantity', (cellValue, flag) => {
  if (!cellValue || cellValue === '') {
    return '0';
  } else {
    cellValue = Number(cellValue);
    const str = cellValue.toString().toUpperCase();
    let intPartFormat = "";
    if (flag) {
      intPartFormat = cellValue
    } else {
      intPartFormat = cellValue.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
    }
    return intPartFormat

  }
});

// 千位符 、 补零
Vue.filter('formatMoney', function (value) {
  if (!value) return '0.00'
  // 将金额转为字符串
  let money = value.toString()
  // 判断是否存在小数点
  if (money.indexOf('.') === -1) {
    // 如果不存在小数点，则自动补全两位小数
    money += '.00'
  } else {
    // 如果存在小数点，则补齐到两位小数
    money += '00'
    money = money.substring(0, money.indexOf('.') + 3)
  }
  // 将金额按照千位分隔符进行格式化，千位符为","
  const reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g
  money = money.replace(reg, '$1,')
  return money
})

// 千位符 、 补零，无数据---
Vue.filter('formatMoney1', function (value) {
  if (!value) return '---'
  // 将金额转为字符串
  let money = value.toString()
  // 判断是否存在小数点
  if (money.indexOf('.') === -1) {
    // 如果不存在小数点，则自动补全两位小数
    money += '.00'
  } else {
    // 如果存在小数点，则补齐到两位小数
    money += '00'
    money = money.substring(0, money.indexOf('.') + 3)
  }
  // 将金额按照千位分隔符进行格式化，千位符为","
  const reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g
  money = money.replace(reg, '$1,')
  return money
})

// 单价四位小数
Vue.filter('priceFormat4', function (value) {
  if (value != null) {
    if (typeof (value) == 'number') {
      // let arr = value.split('')
      let f = false
      if (value.toString()[0] === '-') {
        f = true
        value = value.toString().slice(1)
      }
      value = parseFloat((value + '').replace(/[^\d\.-]/g, '')).toFixed(4) + '';
      const l = value.split('.')[0].split('').reverse();
      const r = value.split('.')[1];
      let t = '';
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '');
      }
      return `${f ? '-' : ''}${t.split('').reverse().join('') + '.' + r}`;
    } else {
      return value;
    }
  } else {
    if (value === 0) {
      return 0
    } else {
      return '--'
    }
  }
})
//什么奇葩显示格式，0-2显示2位小数，3-4位小数有几位显示几位，最多四位小数
Vue.filter('priceFormat', function(value) {
  if (value === null || value === undefined) {
      return '--';
  }
  if (typeof value !== 'number') {
      return value;
  }
  if (value === 0) {
      return '0.00';
  }
  const decimalPart = value.toString().split('.')[1] || '';
  const decimalPlaces = decimalPart.length;
  
  let decimalsToShow;
  if (decimalPlaces <= 2) {
      decimalsToShow = 2;
  } else if (decimalPlaces <= 4) {
      decimalsToShow = decimalPlaces;
  } else {
      decimalsToShow = 4;
  }
  
  // 处理负数
  const isNegative = value < 0;
  const absoluteValue = Math.abs(value);
  
  // 格式化数字
  const formattedNumber = absoluteValue.toLocaleString('en-US', {
      minimumFractionDigits: decimalsToShow,
      maximumFractionDigits: decimalsToShow
  });
  
  return isNegative ? `-${formattedNumber}` : formattedNumber;
});
Object.keys(handleList).forEach(fnName => {
  Vue.filter(fnName, handleList[fnName])
})
